import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { InputText } from "../../../../../../components/Inputs";
import { InputSelect } from "../../../../../../components/Inputs/InputSelect";
import { isStatusSucess } from "../../../../../../helpers/helpers";
import { useLang } from "../../../../../../language";
import { AlquileresServices } from "../services/alquileres.service";
import { convertStaticServiceToArray } from "../../../../../../services/helpers";
import { TarifasServices } from "../../Aparatos/Aparato/controllers/services/tarifas.service";
import { ModalStatusServer } from "../../../../../../components/Modals/ModalStatusServer";
import { Placeholder } from "../../../../../../components/Placeholder/Placeholder";

export const SeccionDatosFacturacion = ({ formInscripcion, handleInputInscripcion, valuesValidationStep2,
  handleFormInscripcion, currentTarifa, setcurrentTarifa, isGratuito, idpedido, changeTarifaFlag,
  setchangeTarifaFlag }: any) => {

  const Lang = useLang()

  // GET tarifas

  const [fetchTarifasGET, fetchTarifasGETData] = TarifasServices.GET_ID()

  // const [changeTarifaFlag, setchangeTarifaFlag] = useState(false);


  useEffect(() => {

    if (formInscripcion.idproducto) {

      fetchTarifasGET({
        id: formInscripcion.idproducto + '/show'
      })
    }

  }, [formInscripcion.idproducto])

  const [fetchGetTarifasCondicionesPago, fetchGetTarifasCondicionesPagoData] = AlquileresServices.GET_TARIFAS_CONDICIONES_PAGO()


  const handleSubmitTarifasCondiciones = (inputidproductotarifa?: any) => {

    let paramTemp: any = {
      idpersona: formInscripcion.idpersona,
      idpersonaentidad: formInscripcion.idpersonaentidad,
      idproducto: formInscripcion.idproducto,
      fechadesde: formInscripcion.fechadesde,
      fechahasta: formInscripcion.fechahasta,
      idpedido: formInscripcion.idpedido,
      idproductotarifa: inputidproductotarifa || formInscripcion.idproductotarifa,
    }

    if (!paramTemp.idpersonaentidad) delete paramTemp.idpersonaentidad
    if (!paramTemp.idpedido) delete paramTemp.idpedido
    if (!paramTemp.idproductotarifa) delete paramTemp.idproductotarifa

    fetchGetTarifasCondicionesPago({
      params: paramTemp
    })
  }

  useEffect(() => {

    if (formInscripcion.idpersona || formInscripcion.idpersonaentidad) {

      handleSubmitTarifasCondiciones()
    }

  }, [formInscripcion.idpersona, formInscripcion.fechadesde, formInscripcion.fechahasta, formInscripcion.idpersonaentidad]);

  useEffect(() => {

    if (isStatusSucess(fetchGetTarifasCondicionesPagoData.status)) {

      // handleFormInscripcion({
      //   ...formInscripcion,
      //   // idproductotarifa: fetchGetTarifasCondicionesPagoData.data?.tarifas?.idproductotarifa,
      // })

      if (!idpedido) {

        handleFormInscripcion({
          ...formInscripcion,
          idproductotarifa: fetchGetTarifasCondicionesPagoData.data?.tarifas?.idproductotarifa,
        })

        setcurrentTarifa({
          totalimportebase: Number(fetchGetTarifasCondicionesPagoData.data?.totalimportebase || 0),
          importeiva: Number(fetchGetTarifasCondicionesPagoData.data?.iva?.porcentajeiva || 0),
          totalimportetotal: Number(fetchGetTarifasCondicionesPagoData.data?.totalimportetotal || 0),
          idiva: fetchGetTarifasCondicionesPagoData.data?.iva?.idiva || ''
        })

      } else {


        handleFormInscripcion({
          ...formInscripcion,
          // idproductotarifa: fetchGetTarifasCondicionesPagoData.data?.tarifas?.idproductotarifa,
        })

        if (changeTarifaFlag) {

          setcurrentTarifa({
            totalimportebase: Number(fetchGetTarifasCondicionesPagoData.data?.totalimportebase || 0),
            importeiva: Number(fetchGetTarifasCondicionesPagoData.data?.iva?.porcentajeiva || 0),
            totalimportetotal: Number(fetchGetTarifasCondicionesPagoData.data?.totalimportetotal || 0),
            idiva: fetchGetTarifasCondicionesPagoData.data?.iva?.idiva || ''
          })
        }

      }

    }
  }, [fetchGetTarifasCondicionesPagoData]);

  const handleChangeTarifas = (e: any) => {

    setchangeTarifaFlag(true)

    handleSubmitTarifasCondiciones(e.target.value)
  }

  const handleChangeImporteBase = (e: any) => {

    const totalimportebase = e.target.value;
    const importeiva = currentTarifa?.importeiva
    const idiva = currentTarifa?.idiva

    const totalimportetotal = totalimportebase ? Number((Number(totalimportebase) + (importeiva / 100 * Number(totalimportebase))).toFixed(2)) : 0

    setcurrentTarifa({
      idiva,
      totalimportebase: totalimportebase,
      importeiva,
      totalimportetotal
    })
  }

  return (
    <>
      {
        fetchTarifasGETData?.loading ?
          <LoaderFormDatosFacturacion />
          :
          <>
            <ModalStatusServer fetchData={fetchGetTarifasCondicionesPagoData} onlyError />

            <Form.Group className={`mb-3 col-12 ${idpedido ? 'col-sm-4' : 'col-sm-5'}`}>
              <InputSelect
                label={`${Lang('TARIFA')}: ${isGratuito ? '' : '*'}`}
                name='idproductotarifa'
                value={formInscripcion.idproductotarifa}
                onChange={(e: any) => {

                  handleInputInscripcion(e)
                  handleChangeTarifas(e)
                }}

                values={fetchTarifasGETData.data?.items?.map((item: any) => {
                  return {
                    id: item.id,
                    nombre: item.tarifa,
                  }
                }) || []}
                validation={valuesValidationStep2}
              />
            </Form.Group>

            <Form.Group className="mb-3 col-12 col-sm-4">
              <InputSelect
                label={`${Lang('CONDICION_DE_PAGO')}: ${isGratuito ? '' : '*'}`}
                name='idcondicionpago'
                value={formInscripcion.idcondicionpago}
                onChange={handleInputInscripcion}
                values={convertStaticServiceToArray(fetchGetTarifasCondicionesPagoData.data?.condicionespagos || {}) || []}
                validation={valuesValidationStep2}
              // readonly={idpedido}
              />
            </Form.Group>

            <div className="col-12"></div>

            {
              // currentTarifa.precio &&
              //  !idpedido &&
              <>
                <Form.Group className="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                  <Form.Label className='fw-500'>{Lang('IMPORTE_BASE') + ':'}</Form.Label>
                  <div className="d-flex align-items-center">
                    <InputText
                      name='totalimportebase'
                      type='number'
                      value={(currentTarifa?.totalimportebase || '')}
                      onChange={handleChangeImporteBase}
                    />
                    <strong className="ms-2 me-2">€</strong>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3 col-12 col-md-6 col-lg-2">
                  <InputText
                    label={'IVA:'}
                    name='importe'
                    value={(currentTarifa?.importeiva || '') + ' %'}
                    onChange={handleInputInscripcion}
                    readonly={true}
                  />
                </Form.Group>

                <Form.Group className="mb-3 col-12 col-md-6 col-lg-3">
                  <InputText
                    label={Lang('IMPORTE_TOTAL') + ':'}
                    name='totalimportetotal'
                    value={(currentTarifa?.totalimportetotal || '') + ' €'}
                    onChange={handleInputInscripcion}
                    readonly={true}
                  />
                </Form.Group>
              </>
            }

          </>
      }

    </>
  )
};

const LoaderFormDatosFacturacion = () => {
  return (
    <>
      <Placeholder width="50%" height="2rem" className="mb-3" />
      <Placeholder width="50%" height="2rem" className="mb-3 delay-1" />
      <Placeholder width="50%" height="2rem" className="" />
      <Placeholder width="50%" height="2rem" className="delay-1" />
    </>
  )
}